// extracted by mini-css-extract-plugin
module.exports = {"itemCaution":"SerialCodeModal_itemCaution__0hyyU","textSerialCode":"SerialCodeModal_textSerialCode__Rjinr","contentWrapper":"SerialCodeModal_contentWrapper__Ffgfx"};